import React from "react";

export default function PrivacyInstagram() {
  return (
    <main style={{ padding: 24, maxWidth: 900, margin: "0 auto", fontFamily: "system-ui, sans-serif", lineHeight: 1.6 }}>
      <h1>Política de Privacidad</h1>
      <p><strong>Última actualización:</strong> 23 de diciembre de 2025</p>

      <section style={{ marginTop: 32 }}>
        <h2>1. Introducción</h2>
        <p>
          En Geves, respetamos su privacidad y nos comprometemos a proteger sus datos personales.
          Esta Política de Privacidad explica cómo recopilamos, usamos, almacenamos y protegemos su
          información cuando utiliza nuestro servicio.
        </p>
        <p>
          Al utilizar Geves, usted acepta las prácticas descritas en esta política. Si no está de
          acuerdo, por favor no utilice nuestro servicio.
        </p>
      </section>

      <section style={{ marginTop: 32 }}>
        <h2>2. Información que Recopilamos</h2>

        <h3>2.1 Información de Cuenta</h3>
        <p>Cuando crea una cuenta en Geves, recopilamos:</p>
        <ul>
          <li>Nombre completo</li>
          <li>Dirección de correo electrónico</li>
          <li>Contraseña (almacenada de forma cifrada)</li>
          <li>Información de perfil opcional (foto, biografía, etc.)</li>
        </ul>

        <h3>2.2 Información de Redes Sociales Conectadas</h3>
        <p>Cuando conecta sus cuentas de redes sociales (TikTok, Instagram, etc.), recopilamos:</p>
        <ul>
          <li><strong>Identificadores de cuenta:</strong> ID de usuario, nombre de usuario, open_id</li>
          <li><strong>Tokens de acceso:</strong> Almacenados de forma cifrada para realizar operaciones autorizadas</li>
          <li><strong>Información de perfil:</strong> Foto de perfil, biografía, seguidores, seguidos</li>
          <li><strong>Contenido:</strong> Posts, videos, imágenes que usted programa o publica</li>
          <li><strong>Métricas:</strong> Likes, comentarios, vistas, engagement, alcance</li>
          <li><strong>Datos de autorización:</strong> Permisos concedidos, fecha de conexión</li>
        </ul>

        <h3>2.3 Información de Uso</h3>
        <p>Recopilamos automáticamente información sobre cómo utiliza el servicio:</p>
        <ul>
          <li>Direcciones IP</li>
          <li>Tipo de navegador y dispositivo</li>
          <li>Sistema operativo</li>
          <li>Páginas visitadas y acciones realizadas</li>
          <li>Fecha y hora de acceso</li>
          <li>URLs de referencia</li>
        </ul>

        <h3>2.4 Cookies y Tecnologías Similares</h3>
        <p>
          Utilizamos cookies y tecnologías similares para mejorar su experiencia, mantener su sesión
          activa y analizar el uso del servicio. Puede controlar las cookies a través de la configuración
          de su navegador.
        </p>
      </section>

      <section style={{ marginTop: 32 }}>
        <h2>3. Cómo Usamos su Información</h2>
        <p>Utilizamos la información recopilada para:</p>
        <ul>
          <li><strong>Proporcionar el servicio:</strong> Publicar contenido, programar posts, mostrar métricas</li>
          <li><strong>Autenticación y seguridad:</strong> Verificar su identidad y proteger su cuenta</li>
          <li><strong>Comunicación:</strong> Enviar notificaciones importantes sobre el servicio</li>
          <li><strong>Mejora del servicio:</strong> Analizar el uso y desarrollar nuevas funcionalidades</li>
          <li><strong>Soporte técnico:</strong> Resolver problemas y responder a sus consultas</li>
          <li><strong>Cumplimiento legal:</strong> Cumplir con obligaciones legales y regulatorias</li>
          <li><strong>Prevención de fraude:</strong> Detectar y prevenir actividades fraudulentas o abusivas</li>
        </ul>
      </section>

      <section style={{ marginTop: 32 }}>
        <h2>4. Compartir Información con Terceros</h2>

        <h3>4.1 Plataformas de Redes Sociales</h3>
        <p>
          Compartimos información con las plataformas que usted conecta (TikTok, Instagram, etc.)
          únicamente según los permisos que usted autoriza, como publicar contenido o obtener métricas.
        </p>

        <h3>4.2 Proveedores de Servicios</h3>
        <p>
          Compartimos datos con proveedores de servicios que nos ayudan a operar el negocio:
        </p>
        <ul>
          <li>Servicios de hosting y almacenamiento en la nube</li>
          <li>Servicios de análisis y monitoreo</li>
          <li>Procesadores de pago</li>
          <li>Servicios de email y comunicaciones</li>
        </ul>
        <p>
          Estos proveedores están contractualmente obligados a proteger sus datos y solo pueden
          usarlos para proporcionar servicios en nuestro nombre.
        </p>

        <h3>4.3 No Vendemos sus Datos</h3>
        <p>
          <strong>No vendemos, alquilamos ni compartimos su información personal con terceros para
          sus propios fines de marketing.</strong>
        </p>

        <h3>4.4 Divulgación Legal</h3>
        <p>
          Podemos divulgar su información si es requerido por ley o para:
        </p>
        <ul>
          <li>Cumplir con procesos legales o solicitudes gubernamentales</li>
          <li>Proteger los derechos, propiedad o seguridad de Geves, nuestros usuarios o el público</li>
          <li>Prevenir fraude o actividades ilegales</li>
        </ul>
      </section>

      <section style={{ marginTop: 32 }}>
        <h2>5. Almacenamiento y Seguridad de Datos</h2>

        <h3>5.1 Medidas de Seguridad</h3>
        <p>Implementamos medidas de seguridad técnicas y organizativas para proteger sus datos:</p>
        <ul>
          <li>Cifrado de datos en tránsito (HTTPS/TLS) y en reposo</li>
          <li>Tokens de acceso almacenados con cifrado AES-256</li>
          <li>Contraseñas hasheadas con algoritmos seguros (bcrypt)</li>
          <li>Autenticación de dos factores disponible</li>
          <li>Monitoreo de seguridad y auditorías regulares</li>
          <li>Acceso restringido a datos personales solo para personal autorizado</li>
          <li>Copias de seguridad regulares y encriptadas</li>
        </ul>

        <h3>5.2 Ubicación de Datos</h3>
        <p>
          Sus datos pueden ser almacenados y procesados en servidores ubicados en diferentes países,
          incluyendo pero no limitado a Chile y Estados Unidos. Al utilizar el servicio, usted
          consiente la transferencia internacional de sus datos.
        </p>

        <h3>5.3 Retención de Datos</h3>
        <p>
          Retenemos su información personal mientras su cuenta esté activa o según sea necesario
          para proporcionarle servicios. Después de la eliminación de la cuenta, conservamos ciertos
          datos por períodos específicos:
        </p>
        <ul>
          <li>Datos de transacciones: 7 años (requisito legal)</li>
          <li>Logs de seguridad: 1 año</li>
          <li>Datos de respaldo: 90 días</li>
        </ul>
      </section>

      <section style={{ marginTop: 32 }}>
        <h2>6. Sus Derechos y Opciones</h2>

        <h3>6.1 Acceso y Portabilidad</h3>
        <p>
          Puede acceder a sus datos personales en cualquier momento desde la configuración de su cuenta.
          También puede solicitar una copia de sus datos en formato portable.
        </p>

        <h3>6.2 Corrección</h3>
        <p>
          Puede actualizar o corregir su información personal desde la configuración de su cuenta
          en cualquier momento.
        </p>

        <h3>6.3 Eliminación</h3>
        <p>
          Puede solicitar la eliminación de su cuenta y datos asociados en cualquier momento:
        </p>
        <ul>
          <li>Desde la configuración de su cuenta (eliminación automática)</li>
          <li>Contactándonos en <a href="mailto:legal@geves.cl" style={{ color: "#0066cc" }}>legal@geves.cl</a></li>
        </ul>
        <p>
          Procesaremos su solicitud dentro de 30 días. Algunos datos pueden ser retenidos según
          requisitos legales.
        </p>

        <h3>6.4 Revocación de Acceso a Redes Sociales</h3>
        <p>
          Puede revocar el acceso de Geves a sus cuentas de redes sociales:
        </p>
        <ul>
          <li>Desde la configuración de su cuenta en Geves</li>
          <li>Desde la configuración de permisos en la plataforma correspondiente (TikTok, Instagram, etc.)</li>
        </ul>

        <h3>6.5 Objeción y Limitación</h3>
        <p>
          Puede objetar ciertos procesamientos de datos o solicitar limitaciones contactándonos
          en legal@geves.cl.
        </p>

        <h3>6.6 Comunicaciones de Marketing</h3>
        <p>
          Puede optar por no recibir comunicaciones de marketing en cualquier momento haciendo clic
          en "cancelar suscripción" en los emails o desde la configuración de su cuenta.
        </p>
      </section>

      <section style={{ marginTop: 32 }}>
        <h2>7. Privacidad de Menores</h2>
        <p>
          Nuestro servicio no está dirigido a menores de 18 años. No recopilamos intencionalmente
          información personal de menores. Si descubrimos que hemos recopilado datos de un menor,
          eliminaremos esa información inmediatamente.
        </p>
        <p>
          Si es padre o tutor y cree que su hijo nos ha proporcionado información personal,
          contáctenos en legal@geves.cl.
        </p>
      </section>

      <section style={{ marginTop: 32 }}>
        <h2>8. Cumplimiento con Regulaciones</h2>
        <p>
          Cumplimos con las leyes de protección de datos aplicables, incluyendo:
        </p>
        <ul>
          <li>Ley N° 19.628 sobre Protección de la Vida Privada (Chile)</li>
          <li>GDPR (Reglamento General de Protección de Datos) para usuarios en la UE</li>
          <li>CCPA (Ley de Privacidad del Consumidor de California) para usuarios en California</li>
        </ul>
      </section>

      <section style={{ marginTop: 32 }}>
        <h2>9. Transferencias Internacionales de Datos</h2>
        <p>
          Al utilizar servicios en la nube y APIs de terceros (TikTok, Instagram, etc.), sus datos
          pueden ser transferidos y procesados en otros países. Implementamos salvaguardas apropiadas
          como cláusulas contractuales estándar para proteger sus datos durante transferencias
          internacionales.
        </p>
      </section>

      <section style={{ marginTop: 32 }}>
        <h2>10. Cambios a esta Política</h2>
        <p>
          Nos reservamos el derecho de actualizar esta Política de Privacidad periódicamente.
          Le notificaremos sobre cambios significativos mediante:
        </p>
        <ul>
          <li>Publicación de la política actualizada en esta página</li>
          <li>Actualización de la fecha de "Última actualización"</li>
          <li>Envío de un email a su dirección registrada (para cambios importantes)</li>
        </ul>
        <p>
          Le recomendamos revisar esta política periódicamente. Su uso continuado del servicio
          después de cambios constituye su aceptación de la nueva política.
        </p>
      </section>

      <section style={{ marginTop: 32 }}>
        <h2>11. Contacto y Preguntas</h2>
        <p>
          Si tiene preguntas, inquietudes o solicitudes relacionadas con esta Política de Privacidad
          o el procesamiento de sus datos personales, puede contactarnos:
        </p>
        <p>
          <strong>Email:</strong> <a href="mailto:legal@geves.cl" style={{ color: "#0066cc" }}>legal@geves.cl</a><br />
          <strong>Website:</strong> <a href="https://calendario.geves.cl" style={{ color: "#0066cc" }}>https://calendario.geves.cl</a>
        </p>
        <p>
          Responderemos a su solicitud dentro de 30 días hábiles.
        </p>
      </section>

      <section style={{ marginTop: 32 }}>
        <h2>12. Autoridad de Supervisión</h2>
        <p>
          Si considera que no hemos abordado adecuadamente sus inquietudes, tiene derecho a
          presentar una queja ante la autoridad de protección de datos de su jurisdicción.
        </p>
        <p>
          En Chile: Consejo para la Transparencia (<a href="https://www.consejotransparencia.cl" target="_blank" rel="noopener noreferrer" style={{ color: "#0066cc" }}>www.consejotransparencia.cl</a>)
        </p>
      </section>

      <footer style={{ marginTop: 48, paddingTop: 24, borderTop: "1px solid #e5e7eb", fontSize: 14, color: "#6b7280" }}>
        <p>© 2025 Geves. Todos los derechos reservados.</p>
        <p>
          <a href="/instagram/privacy-policy" style={{ color: "#0066cc", marginRight: 16 }}>Política de Privacidad</a>
          <a href="/instagram/terms-of-service" style={{ color: "#0066cc" }}>Términos de Servicio</a>
        </p>
      </footer>
    </main>
  );
}
